import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";
import bgimage from '../../../../images/raw_material/default_rawmaterial.png';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import { Row, Col, Tab, Nav } from "react-bootstrap";
import moment from 'moment';
import axios from 'axios';

const Manage_Wastage = () => { 

    const onInit = () => {};
    const tableRef = useRef(null);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [key, setKey] = useState('raw_material');
    const [filterOpen, setFilterOpen] = useState(false);

    const [dateFilter, setDateFilter] = useState("all");
    const [todayDate, setTodayDate] = useState(new Date());
    const [weekStartDate, setWeekStartDate] = useState(moment().startOf('isoWeek').toDate());
    const [weekEndDate, setWeekEndDate] = useState(moment().endOf('isoWeek').toDate());
    const [monthDate, setMonthDate] = useState(new Date());
    const [customStartDate, setCustomStartDate] = useState(new Date());
    const [customEndDate, setCustomEndDate] = useState(new Date());

    const [wastageList, setWastageList] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [searchTerm, setSearchTerm] = useState('');

    const dateFilterOptions = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];

    // 🔥 Debounce search
    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            fetchWastage(true);
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchTerm]);

const fetchWastage = (applyFilter = false) => {

    const params = {
        page,
        per_page: perPage,
        search: searchTerm
    };

    // Apply date filters only when needed
    if (applyFilter && dateFilter !== "all") {

        // TODAY
        if (dateFilter === "today") {
            const d = moment(todayDate).format("YYYY-MM-DD");
            params.start_date = d;
            params.end_date = d;
        }

        // THIS WEEK
        else if (dateFilter === "this_week") {
            params.start_date = moment(weekStartDate).format("YYYY-MM-DD");
            params.end_date = moment(weekEndDate).format("YYYY-MM-DD");
        }

        // THIS MONTH  🔥 FIXED
        else if (dateFilter === "this_month") {
            const start = moment(monthDate).startOf("month").format("YYYY-MM-DD");
            const end = moment(monthDate).endOf("month").format("YYYY-MM-DD");
            params.start_date = start;
            params.end_date = end;
        }

        // CUSTOM RANGE
        else if (dateFilter === "custom") {
            params.start_date = moment(customStartDate).format("YYYY-MM-DD");
            params.end_date = moment(customEndDate).format("YYYY-MM-DD");
        }
    }

    axios.get(`${baseURL}/storage-wastage`, { params })
        .then(res => {
            const { data, total_count } = res.data;

            setWastageList(data.data || data);
            setTotalCount(total_count);
            setTotalPages(Math.ceil(total_count / perPage));

            setTimeout(() => {
                if ($.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable().destroy();
                }
                $(tableRef.current).DataTable({
                    responsive: true,
                    ordering: false,
                    searching: false,
                    paging: false,
                    info: false
                });
            }, 100);
        })
        .catch(err => console.error(err));
};


    const handleResetFilter = () => {
        setDateFilter("all");
        setTodayDate(new Date());
        setWeekStartDate(moment().startOf('isoWeek').toDate());
        setWeekEndDate(moment().endOf('isoWeek').toDate());
        setMonthDate(new Date());
        setCustomStartDate(new Date());
        setCustomEndDate(new Date());
        setPage(1);
        setSearchTerm('');
        fetchWastage(false);
    };

    const handleApplyFilter = () => {
        setPage(1);
        fetchWastage(true);
        setFilterOpen(false);
    };

useEffect(() => {
    fetchWastage(dateFilter !== "all");
}, [page, perPage]);


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <h4 className='breadcrumb-header'>Manage Wastage</h4>
                </div>
                <div className='d-flex gap-2'>
                    <label className='fs-5 text-danger font-w600'>{moment().format("DD-MMM-YYYY")}</label>
                    <Button variant="primary" size="sm" onClick={() => setFilterOpen(true)}>
                        <i className="fa-solid fa-filter me-2"></i> Filter
                    </Button>
                </div>
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="raw_material">
                                    <Link to="/manage-wastage" className="d-flex align-items-center text-decoration-none">
                                        <i className="fa-solid fa-sack-xmark me-2"></i>
                                            <label className="fs-6">
                                            Raw Material Wastage
                                        </label> 
                                         
                                    </Link>
                                </Nav.Link>
                            </Nav.Item> 
                            
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="food_waste">
                                    <Link to="/manage-food-wastage" className="d-flex align-items-center text-decoration-none">
                                        <i class="fa-solid fa-drumstick-bite me-2"></i>
                                        <label className="fs-6">
                                            Food Wastage
                                        </label>
                                        
                                    </Link>
                                </Nav.Link>
                            </Nav.Item> 
                        </Nav>

                        <Tab.Content className="pt-4">
                            <Tab.Pane eventKey="raw_material">
                                <Row>
                                    <Col xl={12}>
                                        <div className="table-container">

                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div>
                                                    <label className="me-2">Show</label>
                                                    <select
                                                        className="form-select d-inline w-auto"
                                                        value={perPage}
                                                        onChange={(e) => {
                                                            setPerPage(Number(e.target.value));
                                                            setPage(1);
                                                        }}>
                                                        <option value={10}>10</option>
                                                        <option value={25}>25</option>
                                                        <option value={50}>50</option>
                                                        <option value={100}>100</option>
                                                    </select>
                                                </div>

                                                <div>
                                                    <input
                                                        type="text"
                                                        placeholder="Search..."
                                                        className="form-control"
                                                        value={searchTerm}
                                                        onChange={(e) => {
                                                            setSearchTerm(e.target.value);
                                                            setPage(1);
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <table className="item_data_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                                <thead>
                                                    <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head"> 
                                                        <th className='min-w-100px'>Date</th>
                                                        <th className='min-w-50px text-start'>Raw Material</th>
                                                        <th className='min-w-80px text-center'>Brand</th>
                                                        <th className='min-w-80px text-center'>Quantity Wasted</th> 
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7">

                                                    {wastageList.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="4" className="text-center py-4 text-muted fs-6">
                                                                No Data Found
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        wastageList.map((item, index) => (
                                                            <tr key={index}>
                                                                <td className='text-black text-start'> 
                                                                    <label className='text-black font-w400 fs-7'>{moment(item.storagewastage_date).format("DD-MMM-YYYY")}</label>  
                                                                </td> 
                                                                <td>
                                                                    <div className='d-flex align-items-center justify-content-start gap-2'>
                                                                        <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                                            <div data-src={item.image_url || bgimage} className='border rounded px-1 py-0'>
                                                                                <img src={item.image_url || bgimage} alt="Podi Idly" className='cursor-pointer w-50px h-50px' />
                                                                            </div>
                                                                        </LightGallery> 
                                                                        <div className='d-flex flex-column align-items-start'>
                                                                            <label className='text-black font-w400 fs-7'>{item.rawmaterial_name}</label>
                                                                            <label className='text-primary fw-bold font-w400 fs-7'>{item.room_name}</label>
                                                                        </div>
                                                                    </div>
                                                                </td> 
                                                                <td>
                                                                    <div className='d-flex flex-row align-items-center justify-content-center gap-1'> 
                                                                        <label className='text-black font-w400 fs-7'>{item.brand_name || '-'}</label> 
                                                                    </div>
                                                                </td> 
                                                                <td className='text-center text-danger fw-bold fs-5'>
                                                                    {item.storagewastage_quantity} {item.unit_name}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}

                                                </tbody>

                                            </table>

                                            <div className="d-flex justify-content-between mt-3">
                                                <span>
                                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + wastageList.length} of {totalCount}
                                                </span>

                                                <ul className="pagination mb-0">
                                                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                        <button className="page-link" onClick={() => setPage(page - 1)}>Prev</button>
                                                    </li>

                                                    {Array.from({ length: totalPages }).map((_, i) => (
                                                        <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                                            <button className="page-link" onClick={() => setPage(i + 1)}>{i + 1}</button>
                                                        </li>
                                                    ))}

                                                    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                        <button className="page-link" onClick={() => setPage(page + 1)}>Next</button>
                                                    </li>
                                                </ul>
                                            </div>

                                        </div>
                                    </Col>
                                </Row>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>

            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                        padding: 0
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                {/* Header */}
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Filter Wastage</h5>
                    <div>
                        <Button variant="" type="button" size='sm' onClick={() => setFilterOpen(false)}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>

                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>

                            {/* Filter Type */}
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date Filter</label>
                                <Select
                                    value={dateFilterOptions.find(o => o.value === dateFilter)}
                                    onChange={(opt) => setDateFilter(opt.value)}
                                    options={dateFilterOptions}
                                    menuPlacement="top"
                                />
                            </div>

                            {/* TODAY */}
                            {dateFilter === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'>
                                            <i className='fa-solid fa-calendar-days fs-4'></i>
                                        </div>
                                        <DatePicker
                                            value={todayDate}
                                            onChange={setTodayDate}
                                            format="DD-MM-YYYY"
                                        />
                                    </div>
                                </div>
                            )}

                            {/* THIS WEEK */}
                            {dateFilter === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'>
                                                <i className='fa-solid fa-calendar-days fs-4'></i>
                                            </div>
                                            <DatePicker
                                                value={weekStartDate}
                                                onChange={setWeekStartDate}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'>
                                                <i className='fa-solid fa-calendar-days fs-4'></i>
                                            </div>
                                            <DatePicker
                                                value={weekEndDate}
                                                onChange={setWeekEndDate}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* THIS MONTH */}
                            {dateFilter === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'>
                                            <i className='fa-solid fa-calendar-days fs-4'></i>
                                        </div>
                                        <DatePicker
                                            value={monthDate}
                                            onChange={setMonthDate}
                                            format="MMM-YYYY"
                                            onlyMonthPicker
                                        />
                                    </div>
                                </div>
                            )}

                            {/* CUSTOM DATE */}
                            {dateFilter === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'>
                                                <i className='fa-solid fa-calendar-days fs-4'></i>
                                            </div>
                                            <DatePicker
                                                value={customStartDate}
                                                onChange={setCustomStartDate}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'>
                                                <i className='fa-solid fa-calendar-days fs-4'></i>
                                            </div>
                                            <DatePicker
                                                value={customEndDate}
                                                onChange={setCustomEndDate}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}

                        </div>
                    </div>

                    {/* BUTTONS */}
                    <div className="d-flex align-items-center justify-content-center gap-1 pb-3">
                        <Button className="me-2 btn-sm" variant="secondary" onClick={handleResetFilter}>
                            <span className='font-w400'>Reset</span>
                        </Button>

                        <Button className="me-2 btn-sm" variant="primary" onClick={handleApplyFilter}>
                            <span className='font-w400'>Apply</span>
                        </Button>
                    </div>
                </div>
            </Drawer>


        </>
    );
};

export default Manage_Wastage;
